import { useQuery } from 'react-query';
import getPayment from 'data/requests/getPayment';
import { Payment } from 'model/payment';

const usePayment = (brandId: string) => {
  const { data, isLoading, refetch } = useQuery<Payment>(
    ['payment', brandId],
    () => getPayment(brandId),
    {
      enabled: false,
    },
  );

  return { payment: data, isLoading, refetch };
};

export default usePayment;
